import { render, staticRenderFns } from "./AddressChips.vue?vue&type=template&id=71ca4baa"
import script from "./AddressChips.vue?vue&type=script&lang=js"
export * from "./AddressChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports